/** Priority for inline page feedback. Bell notifications stay outside this decision. */

export const INLINE_STATUS_LOADING = 'Loading…';

export type InlineStatusView =
  | { kind: 'loading'; message: string }
  | { kind: 'error'; message: string }
  | { kind: 'empty'; message: string }
  | { kind: 'idle' };

export function resolveInlineStatus(input: {
  loading?: boolean;
  error?: string | null;
  empty?: string | null;
}): InlineStatusView {
  if (input.loading) return { kind: 'loading', message: INLINE_STATUS_LOADING };
  const error = (input.error ?? '').trim();
  if (error) return { kind: 'error', message: error };
  const empty = (input.empty ?? '').trim();
  if (empty) return { kind: 'empty', message: empty };
  return { kind: 'idle' };
}
